<template>
  <div class="essential_information">
    <div class="tabs">
      <span></span>法人信息
      <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
        <i v-show="isEdit" class="tabs_one" @click="goEssentialInformation"></i>
      </el-tooltip>
    </div>
    <el-form v-if="FormDataOne" :inline="true" :label-position="labelPosition" label-width="130px" ref="ruleFormDataOne"
      :model="FormDataOne">
      <el-form-item label="法人姓名">
        <el-input v-model="FormDataOne.legalName" maxlength="30" :disabled="isDis" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="法人身份证号">
        <el-input v-model="FormDataOne.legalId" maxlength="30" :disabled="isDis" placeholder="请输入法人身份证号"></el-input>
      </el-form-item>

      <el-form-item label="法人手机号">
        <el-input v-model="FormDataOne.legalIphone" maxlength="30" :disabled="isDis" placeholder="请输入联系方式"></el-input>
      </el-form-item>
    </el-form>
    <div class="btn" v-if="!isDis">
      <el-button class="cancel" @click="cancel">取消</el-button>
      <el-button class="preservation" @click="preservation">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: {
      type: Object
    }
  },

  watch: {
    userInfo: {
      handler (newVale, oldVale) {
        if (newVale.num === 1) {
          this.id = newVale.id
          this.certificateUrls = newVale.businessLicenseUrls
          this.auditStatus = newVale.auditStatus
          this.FormDataOne.legalName = newVale.legalName;
          this.FormDataOne.legalId = newVale.legalId;
          this.FormDataOne.legalIphone = newVale.legalIphone;
          this.dataObj = { ...this.FormDataOne } // 解构对象，取消操作用解构对象
        }
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    isEdit () {

      if (this.auditStatus === 1) {
        return false
      } else {
        return this.isDis
      }
    },
  },
  data () {
    let isLegalId = (rule, value, callback) => {
      if (value.length !== 18) {
        return callback(new Error("请输入正确身份证号"));
      }
      callback();
    };
    return {
      certificateUrls: [],
      FormDataOne: {
        legalName: "",
        legalId: "",
        legalIphone: "",
      },
      dataObj: {},

      labelPosition: "left",
      isDis: true,
      id: null,
      auditStatus: null,
    };
  },
  created () {

  },
  methods: {
    goEssentialInformation () {
      this.isDis = false
    },
    async preservation () {
      let _this = this
      if (!this.certificateUrls) {
        this.certificateUrls = []
      }
      let url = "/v1/userRegister/add_or_update_company_register_info"
      let myUser = JSON.parse(localStorage.getItem("myUser"))
      let params = {
        id: this.id,
        auditStatus: this.auditStatus === 0 ? 0 : 2,
        userId: myUser.id,
        legalName: this.FormDataOne.legalName,
        legalId: this.FormDataOne.legalId,
        legalIphone: this.FormDataOne.legalIphone,
        certificateUrls: this.certificateUrls
      }
      const res = await this.catReq1Service(url, params)
      if (res.resultCode === "1") {
        this.isDis = true;
        this.$emit("succe", res.result)
      }
    },
    cancel () {
      this.$refs['ruleFormDataOne'].clearValidate();
      this.FormDataOne = { ...this.dataObj }
      this.isDis = true;
    },
  },
};
</script>

<style lang="less" scoped>
.essential_information {
  .tabs {
    display: flex;
    font-size: 16px;
    align-items: center;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(28, 28, 29, 1);
    margin-bottom: 20px;
    span {
      width: 4px;
      height: 16px;
      background: rgba(30, 134, 230, 1);
      margin-right: 5px;
    }
    .tabs_one {
      display: inline-block;
      cursor: pointer;
      width: 16px;
      height: 16px;
      background: url("../../assets/imgs/authentication/modify_normal.png")
        no-repeat;
      background-size: cover;
      margin-left: 10px;
      &:active {
        background: url("../../assets/imgs/authentication/modify_press.png")
          no-repeat;
      }
    }
  }
  .el-form {
    display: flex;
    flex-wrap: wrap; //flex-grow
    .el-form-item {
      width: 40%;
    }
    .el-input {
      width: 202px;
    }
    .sex {
      .el-radio-group {
        position: relative;
        left: -90px;
      }
      .el-form-item__label {
        margin-left: 50px !important;
      }
      /deep/.el-form-item__error {
        left: -90px !important;
      }
    }
  }
  .btn {
    width: 100%;
    text-align: right;
    .el-button {
      width: 80px;
      height: 36px;
      box-sizing: border-box;
      font-family: Microsoft YaHei;
      font-size: 16px;
      line-height: 0;
    }
    .cancel {
      background: rgba(219, 239, 255, 1);
      border: 1px solid rgba(30, 134, 230, 1);
      box-shadow: 0px 3px 8px 0px rgba(153, 153, 153, 0.5);
      border-radius: 4px;
    }
    .preservation {
      background: rgba(30, 134, 230, 1);
      box-shadow: 0px 3px 8px 0px rgba(30, 134, 230, 0.5);
      border-radius: 4px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      margin-left: 50px;
    }
  }
}
</style>
